import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DatabaseProvider } from '../database/database';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { UsersStoreProvider } from '../users-store/users-store';
import { formatDate, areArraysSame } from '../../Utils/CommonUtils';
import { TranslateProvider } from '../translate/translate';
import { ConfigDataProvider } from '../config-data/config-data';

@Injectable()
export class MessageInfoStoreProvider {

	private messagesDetail: any = [];
	private db = new DatabaseProvider();
	private userList = [];

	constructor(
		private usersStore: UsersStoreProvider,
		private translateProvider: TranslateProvider,
		private configDataProvider: ConfigDataProvider,
	) {

		this.usersStore.usersList
			.subscribe((list) => {
				this.userList = [...list];
			})

		this.usersStore.loadList().then(() => { }).catch((e) => { });

	}

	forMessage(conversationId, messageId) {

		conversationId = conversationId + '';
		this.setMessageSubject(conversationId);
		return this.messagesDetail[conversationId]

	}

	loadForMessage(conversationId, messageId) {

		let observable = Observable.fromPromise(this.db.messages.where({ conversationid: conversationId }).toArray())
			.pipe(map((data) => {

				return this.manipulateMessage(data, conversationId, messageId);


			})).pipe(shareReplay());

		observable.subscribe((data) => {

			let messageSubject: BehaviorSubject<any> = this.forMessage(conversationId, messageId);
			messageSubject.next(data);

		}, () => { })

		return observable;


	}


	private setMessageSubject(contactId) {

		contactId = contactId + '';
		if (!this.messagesDetail.hasOwnProperty(contactId))
			this.messagesDetail[contactId] = new BehaviorSubject([]);

	}

	loadMessageForMessageInfoPanel(conversationId, messageId) {

		let observable = Observable.fromPromise(this.db.messages.where({ conversationid: conversationId }).toArray())
			.pipe(map((data) => {

				let messages = this.manipulateMessageInfoList(data, conversationId, messageId);

				let message = messages[0];
				var bestids = message['morebestemmelingenids'];

				var readalready = message['readalready'].split(',');
				var readalreadyarr = [];
				for (var x = 0; x < readalready.length; x++) {
					var ra = {};
					var tmp = readalready[x].split(';');
					ra['id'] = tmp[0];
					ra['time'] = tmp[1];
					readalreadyarr.push(ra);
				}
				var bestarr = [];
				for (var j = 0; j < bestids.length; j++) {
					let tmp = { 'id': bestids[j], 'readtime': '' };
					for (var i = 0; i < this.userList.length; i++) {
						if (this.userList[i].id == bestids[j]) {
							tmp['name'] = this.userList[i].fname;
							tmp['picture'] = this.userList[i].picture;
						}
					}

					for (var i = 0; i < readalreadyarr.length; i++) {
						if (bestids[j] == readalreadyarr[i].id) {
							tmp['readtime'] = formatDate(readalreadyarr[i]['time']);
						}
					}

					bestarr.push(tmp);
				}
				message['readresult'] = bestarr;

				return message;

			})).pipe(shareReplay());

		return observable;
	}

	manipulateMessage(messageList, conversationId, messageId) {

		let messagesArray = {
			messages: [],
			selectedUserList: []
		};
		let addedUserList = [];
		let ids = []

		if (messageList && messageList.length) {

			messageList.forEach((message) => {

				let userData = this.userList.filter((user) => {

					return message.senderuserid == user.id

				})

				let upic = userData && userData.length > 0 ? userData[0].picture : "";
				let fname = userData && userData.length > 0 ? userData[0].fname : "";
				let senderUserId = userData && userData.length > 0 ? userData[0].id : null;

				let tempMessage = {
					customercode: message.customercode,
					id: message.id,
					bestemmelingen: message.bestemmelingen,
					bestemmelingenids: message.bestemmelingenids,
					picture: upic,
					subject: message.subject,
					conversationid: message.conversationid,
					fname: fname,
					datecreated: formatDate(message.datecreated),//message.datecreated,
					msgtext: message.msgtext,
					senderuserid: senderUserId,
					readalready: message.readalready,
					realbestemmelingenids: message.realbestemmelingenids,
					tempDateCreated: message.datecreated
				}

				let tmpbestids = message.bestemmelingenids.split(',');

				if (tmpbestids && tmpbestids.length > 0) {

					tmpbestids.forEach((item) => {

						if (addedUserList.length > 0) {

							addedUserList.forEach((additem) => {

								if (additem.id != item) {

									this.userList.forEach((user) => {
										if (user.id == item && user.id) {
											addedUserList.push(user);
										}
									})

								}

							})

						} else {

							this.userList.forEach((user) => {
								if (user.id == item && user.id) {
									addedUserList.push(user);
								}
							})

						}
					})

				}

				let currentUser = this.configDataProvider.getUserData();

				if (addedUserList && addedUserList.length > 0) {

					addedUserList = addedUserList.filter((user) => {
						return user.id != currentUser.id;
					})

					addedUserList = this.removeDuplicateItems(addedUserList);

				}

				let resultbestids = [];

				if (message.readalready != '' && message.readalready != null) {

					let tmpreadalready = message.readalready.split(',');
					let tmpread = [];

					if (tmpreadalready && tmpreadalready.length > 0) {
						tmpreadalready.forEach((tmp) => {
							let tmpreadal = tmp.split(";");
							tmpread.push(tmpreadal[0]);
						})
					}

					//msg read info
					//if group, check by userids, not groupid
					for (let j = 0; j < tmpbestids.length; j++) {
						//group all in $rootScope.users doesn't exist
						if (tmpbestids[j] == 'G:ALL') {
							this.userList.forEach((item) => {
								if (item.type == 'user') {
									resultbestids.push(item.id);
								}
							});
						}
						else {
							resultbestids.push(tmpbestids[j]);
						}
					}
					//make array unique and sort
					resultbestids = resultbestids.filter(function (item, i, ar) {
						return ar.indexOf(item) === i;
					});
					resultbestids = resultbestids.sort();
					tmpread = tmpread.sort();
					if (areArraysSame(resultbestids, tmpread)) {
						tempMessage['readinfo'] = this.translateProvider.getTranslateKey('ALL_READ');
						tempMessage['readlabel'] = 'all_read';
					}
					else {
						//if not read only by myself
						tempMessage['readinfo'] = this.translateProvider.getTranslateKey('READ_BY') + ' ' + (tmpread.length - 1) + '/' + (resultbestids.length - 1);
						tempMessage['readlabel'] = 'not_all_read';
					}
				}
				else {
					tempMessage['readinfo'] = this.translateProvider.getTranslateKey('READ_BY') + ' 0/' + (resultbestids.length - 1);
					tempMessage['readlabel'] = 'none_read';

				}
				tempMessage['morebestemmelingenids'] = resultbestids;
				messagesArray.messages.push(tempMessage);
				ids.push(message.id);
			})

			messagesArray.messages = messagesArray.messages.sort((d1, d2) => {
				return new Date(d2.tempDateCreated).getTime() - new Date(d1.tempDateCreated).getTime();
			});

			messagesArray.selectedUserList = addedUserList;

			// messagesArray.sort(function (x, y) { return x.id == messageId ? -1 : y.id == messageId ? 1 : 0; });


		}

		return messagesArray;

	}

	manipulateMessageInfoList(messageList, conversationId, messageId) {

		let messageInfoList = [];


		if (messageList && messageList.length > 0) {

			var messageData = messageList.filter(function (data) {
				return data.conversationid == conversationId;
			})

			if (messageId != undefined) {
				messageData = messageData.filter(function (data) {
					return data.id == messageId;
				})
			}

			if (messageData.length > 0) {
				messageInfoList = [];

				var ids = [];
				for (var i = 0; i < messageData.length; i++) {


					var userData = this.userList.filter((user) => {
						return messageData[i].senderuserid == user.id
					})
					// messageData[i].picture = uData.length > 0 ? uData[0].picture : "";
					let upic = userData && userData.length > 0 ? userData[0].picture : "";
					let fname = userData && userData.length > 0 ? userData[0].fname : "";

					var msgr = {
						customercode: messageData[i].customercode,
						id: messageData[i].id,
						bestemmelingen: messageData[i].bestemmelingen,
						bestemmelingenids: messageData[i].bestemmelingenids,
						picture: upic,
						subject: messageData[i].subject,
						conversationid: messageData[i].conversationid,
						fname: fname,
						datecreated: formatDate(messageData[i].datecreated),//messageData[i].datecreated,
						msgtext: messageData[i].msgtext,
						senderuserid: userData.length > 0 ? userData[0].id : null,
						readalready: messageData[i].readalready,
						realbestemmelingenids: messageData[i].realbestemmelingenids,
						tempDateCreated: messageData[i].datecreated
					};

					//MSG READ INFO
					var tmpbestids = messageData[i].realbestemmelingenids.split(',');
					var resultbestids = [];

					if (messageData[i].readalready != '' && messageData[i].readalready != null) {
						var tmpreadalready = messageData[i].readalready.split(',');
						var tmpread = [];
						for (var ta = 0; ta < tmpreadalready.length; ta++) {
							var tmp = tmpreadalready[ta].split(';');
							tmpread.push(tmp[0])
						}

						//msg read info
						//if group, check by userids, not groupid
						for (var xyz = 0; xyz < tmpbestids.length; xyz++) {
							//group all in $rootScope.users doesn't exist
							if (tmpbestids[xyz] == 'G:ALL') {
								this.userList.forEach(function (item) {
									if (item.type == 'user') {
										resultbestids.push(item.id);
									}
								});
							}
							else {
								resultbestids.push(tmpbestids[xyz]);
							}
						}
						//make array unique and sort
						resultbestids = resultbestids.filter(function (item, i, ar) {
							return ar.indexOf(item) === i;
						});
						resultbestids = resultbestids.sort();
						tmpread = tmpread.sort();

						if (areArraysSame(resultbestids, tmpread)) {
							msgr['readinfo'] = this.translateProvider.getTranslateKey('ALL_READ');
							msgr['readlabel'] = 'all_read';
						}
						else {
							//if not read only by myself
							msgr['readinfo'] = this.translateProvider.getTranslateKey('READ_BY') + ' ' + (tmpread.length - 1) + '/' + (resultbestids.length - 1);
							msgr['readlabel'] = 'not_all_read';
						}
					}
					else {
						msgr['readinfo'] = this.translateProvider.getTranslateKey('READ_BY') + ' 0/' + (resultbestids.length - 1);
						msgr['readlabel'] = 'none_read';

					}
					msgr['morebestemmelingenids'] = resultbestids;
					messageInfoList.push(msgr);
					ids.push(messageData[i].id);
				}
				messageInfoList = messageInfoList.sort(function (d1, d2) {
					return new Date(d1.tempDateCreated).getTime() - new Date(d2.tempDateCreated).getTime();
				});
			}


			return messageInfoList;

		}

	}

	removeDuplicateItems(array){
	var uniqueArray = [];
		for(var value of array){
				if(uniqueArray.indexOf(value) === -1){
						uniqueArray.push(value);
				}
		}
		return uniqueArray;
}


}



// WEBPACK FOOTER //
// ./src/providers/message-info-store/message-info-store.ts